__turbopack_context__.v({
  "active": "customer-stories-module__8k__eW__active",
  "card": "customer-stories-module__8k__eW__card",
  "cardIcon": "customer-stories-module__8k__eW__cardIcon",
  "cardLabel": "customer-stories-module__8k__eW__cardLabel",
  "carousel": "customer-stories-module__8k__eW__carousel",
  "cursorPill": "customer-stories-module__8k__eW__cursorPill",
  "edge": "customer-stories-module__8k__eW__edge",
  "edgeBlur": "customer-stories-module__8k__eW__edgeBlur",
  "edgeFade": "customer-stories-module__8k__eW__edgeFade",
  "edgeLeft": "customer-stories-module__8k__eW__edgeLeft",
  "edgeRight": "customer-stories-module__8k__eW__edgeRight",
  "hasHover": "customer-stories-module__8k__eW__hasHover",
  "isArriving": "customer-stories-module__8k__eW__isArriving",
  "isLeaving": "customer-stories-module__8k__eW__isLeaving",
  "logo": "customer-stories-module__8k__eW__logo",
  "mono": "customer-stories-module__8k__eW__mono",
  "pillVisible": "customer-stories-module__8k__eW__pillVisible",
  "root": "customer-stories-module__8k__eW__root",
  "rootOpenSides": "customer-stories-module__8k__eW__rootOpenSides",
  "track": "customer-stories-module__8k__eW__track",
  "voice": "customer-stories-module__8k__eW__voice",
  "voiceBody": "customer-stories-module__8k__eW__voiceBody",
  "voiceContent": "customer-stories-module__8k__eW__voiceContent",
  "voiceCta": "customer-stories-module__8k__eW__voiceCta",
  "voiceCtaButton": "customer-stories-module__8k__eW__voiceCtaButton",
  "voiceCtaLink": "customer-stories-module__8k__eW__voiceCtaLink",
  "voiceCtaTitle": "customer-stories-module__8k__eW__voiceCtaTitle",
  "voiceOrg": "customer-stories-module__8k__eW__voiceOrg",
  "voiceQuote": "customer-stories-module__8k__eW__voiceQuote",
  "voiceSource": "customer-stories-module__8k__eW__voiceSource",
  "voiceTestimonial": "customer-stories-module__8k__eW__voiceTestimonial",
  "voices": "customer-stories-module__8k__eW__voices",
  "wordmark": "customer-stories-module__8k__eW__wordmark",
  "wrapper": "customer-stories-module__8k__eW__wrapper",
});
